import cookies from 'js-cookie'
import { path } from 'ramda'
import { combineReducers } from 'redux'

import session, { logout } from '@/app/module/auth/store/session.slice'
import campaignItem from '@/app/module/campaigns/store/slices/campaign-item.slice'
import cati from '@/app/module/cati/store/reducer'
import contacts from '@/app/module/contacts/store/reducer'
import conversations from '@/app/module/conversations/store/reducer'
import customFields from '@/app/module/custom-fields/store/reducer'
import files from '@/app/module/files/store/reducer'
import groups from '@/app/module/groups/store/reducer'
import logs from '@/app/module/logs/store/reducer'
import notifications from '@/app/module/notifications/store/reducer'
import phoneNumberFiles from '@/app/module/phonenumbers/store/phone-number-files.slice'
import plans from '@/app/module/plans/store/reducer'
import segments from '@/app/module/segments/store/reducer'
import { ACTION_SWITCH_ORGANIZATION_SUCCESS } from '@/app/module/user/definitions'
import user from '@/app/module/user/store/reducer'
import utils from '@/app/module/utils/store/reducer'

import { esApi } from './api'
import { defaultState } from './state'

const appReducers = combineReducers({
  user,
  contacts,
  customFields,
  logs,
  conversations,
  notifications,
  utils,
  groups,
  segments,
  files,
  plans,
  cati,
  campaignItem,
  phoneNumberFiles,
  session,
  [esApi.reducerPath]: esApi.reducer,
})

export default (state: any = {}, action: any = {}) => {
  if (action.type === ACTION_SWITCH_ORGANIZATION_SUCCESS) {
    cookies.remove('trialMode')
    return appReducers(
      {
        ...state,
        user: state.user,
        utils: state.utils,
        contacts: {
          ...defaultState.contacts,
          list: {
            ...defaultState.contacts.list,
            data: {
              ...defaultState.contacts.list.data,
              size: path(['contacts', 'list', 'data', 'size'], state),
            },
          },
        },
        conversations: defaultState.conversations,
        logs: {
          ...defaultState.logs,
          data: {
            ...defaultState.logs.data,
            filters: path(['logs', 'data', 'filters'], state),
          },
        },
        plans: {
          ...state.plans,
        },
        cati: {
          ...state.cati,
          item: defaultState.cati.item,
        },
        session: {
          ...state.session,
          trialMode: false,
        },
      },
      action,
    )
  }
  if (action.type === logout.type) {
    return appReducers(
      {
        utils: state.utils,
      },
      action,
    )
  }
  return appReducers(state, action)
}
